export default __webpack_public_path__ + "static/media/txt.9739850a.svg";